/**
 * Returns a string containing the original `value` left padded with zeros
 */
export function leftPad(value: number | string, size: number) {
  let str = value.toString();
  while (str.length < size) str = "0" + str;
  return str;
}
